import { watchEffect as h, ref as s } from "vue";
import { dom as m } from "./index339.js";
let n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
function c(l, f = s(!0)) {
  h((o) => {
    var a;
    if (!f.value) return;
    let e = m(l);
    if (!e) return;
    o(function() {
      var d;
      if (!e) return;
      let i = (d = t.get(e)) != null ? d : 1;
      if (i === 1 ? t.delete(e) : t.set(e, i - 1), i !== 1) return;
      let r = n.get(e);
      r && (r["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r["aria-hidden"]), e.inert = r.inert, n.delete(e));
    });
    let u = (a = t.get(e)) != null ? a : 0;
    t.set(e, u + 1), u === 0 && (n.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0);
  });
}
export {
  c as useInert
};
